import type { ReactNode } from 'react';
import styles from './Badge.module.css';

export type BadgeTone = 'ok' | 'warn' | 'danger' | 'info' | 'neutral' | 'primary';

interface BadgeProps {
  tone?: BadgeTone;
  dot?: boolean;
  icon?: ReactNode;
  children: ReactNode;
}

/** A small pill badge — status ("Draft", "Finalized"), category tags, "In use". */
export function Badge({ tone = 'neutral', dot, icon, children }: BadgeProps): React.JSX.Element {
  return (
    <span className={`${styles.badge} ${styles[tone]}`}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {icon}
      {children}
    </span>
  );
}
